import useScrollAnimation from '../hooks/useScrollAnimation'
import Hero from '../components/Hero'
import WhySection from '../components/WhySection'
import TreksSection from '../components/TreksSection'
import GuideBar from '../components/GuideBar'
import PopularDestinations from '../components/PopularDestinations'
import DeparturesPreview from '../components/DeparturesPreview'
import ReviewsSection from '../components/ReviewsSection'
import ProcessSteps from '../components/ProcessSteps'
import HomeFAQ from '../components/HomeFAQ'
import WACTASection from '../components/WACTASection'
import BlogPreview from '../components/BlogPreview'
import NewsletterSection from '../components/NewsletterSection'

export default function Home() {
  useScrollAnimation()

  return (
    <main>
      <Hero />
      <WhySection />
      <TreksSection />
      <GuideBar />
      <PopularDestinations />
      <DeparturesPreview />
      <ReviewsSection />
      <ProcessSteps />
      <HomeFAQ />
      <WACTASection />
      <BlogPreview />
      <NewsletterSection />
    </main>
  )
}
